import type { LoadingSkeletonProps } from './types.js';

/** See index.d.ts for @finn-no/tjt-common-components for end user documentation.
 */
const LoadingSkeleton = (props: LoadingSkeletonProps) => {
    const { className = 'w-full', style = { height: '20px' } } = props;
    return <div className={`tjt-skeleton ${className}`} style={style}></div>;
};

export default LoadingSkeleton;
